import { postApi } from 'apis';

const checkBankBalance = async (bankData: any) => {
	return await postApi(`/bank-details/check-balance`, bankData);
};

export const bankIntegrationApi = { checkBankBalance };
